export enum UserPlanPaymentStatus {
  USERPLAN_PAYMENT_UNSET_STATUS = 'USERPLAN_PAYMENT_UNSET_STATUS', // Do not use, needed because of proto3 limitations
  USERPLAN_PAYMENT_PAID = 'USERPLAN_PAYMENT_PAID',
  USERPLAN_PAYMENT_UNPAID = 'USERPLAN_PAYMENT_UNPAID',
}
